<template>
    <div class="sui-waterfall">
        <ul ref="pipe"
            v-for="(list, col) in renderData"
            :key="col"
            :style="{ 'width' : `calc(100% / ${ renderData.length })` }">
            <li v-for="(item, index) in list"
                :key="item[keyName]">
                <slot :item="item" :col="col" :index="index"></slot>
            </li>
        </ul>
    </div>
</template>

<script>
import SuiScroll from '../scroll/scroll'

export default {
    name: 'sui-waterfall',

    components: {
        SuiScroll
    },

    props: {

        // 竖屏列数
        portrait: {
            type: Number,
            default: 1
        },

        // 横屏列数
        landscape: {
            type: Number,
            default: 2
        },

        keyName: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            data: [], // 原始数据
            renderData: [], // 分割后实际用于渲染的数据
        }
    },

    mounted() {
        window.addEventListener('resize', this.init)
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.init)
    },

    methods: {

        /**
         * 重置瀑布流
         * @param {Array} data - 瀑布流初始数据
         */
        reset(data) {
            this.data = data
            this.init()
        },

        /**
         * 追加数据
         * @param {Array} data - 原始对象数组
         */
        appendData(data) {
            this.data = this.data.concat(data)
            if (this.renderData.length > 1) {
                this.render(data)
            } else {
                this.renderData = [this.renderData[0].concat(data)]
            }
        },

        /**
         * 删除某条数据
         * @param {Number} col - 数据所在的列
         * @param {Number} index - 数据在其列中的索引
         */
        delete(col, index) {
            this.$delete(this.renderData[col], index)
        },

        init() {
            const column = window.innerWidth == Math.min(screen.width, screen.height) ? this.portrait : this.landscape
            if (column > 1) {
                this.renderData = []
                for (let i = 0; i < column; i++) {
                    this.$set(this.renderData, i, [])
                }
                this.render()
            } else {
                this.renderData = [this.data]
            }
        },

        /**
         * 渲染多列数据
         * @param {Array} data - 原始对象数组
         */
        render(data = this.data) {
            if (data.length < 1) {
                return
            }
            
            let index = 0
            appendItem.call(this)
            function appendItem() {
                this.$nextTick(() => {
                    let minIndex = 0
                    for (let i = 1; i < this.$refs.pipe.length; i++) {
                        if (this.$refs.pipe[i].clientHeight < this.$refs.pipe[minIndex].clientHeight) {
                            minIndex = i
                        }
                    }
                    this.renderData[minIndex].push(data[index])
                    if (data.length > ++index) {
                        appendItem.call(this)
                    }
                })
            }
        },
    }
}
</script>

<style lang="postcss">
.sui-waterfall {
    display: flex;
    align-items: start;
    ul {
        margin: 0;
        padding: 0;
        li {
            margin: 0;
            padding: 0;
            list-style-type: none;
        }
    }
}
</style>
